import { ChevronDownIcon } from '@forge/common';

interface ShowMoreToggleProps {
  expanded: boolean;
  onToggle: () => void;
  moreLabel: string;
  lessLabel?: string;
}

const ShowMoreToggle = ({
  expanded,
  onToggle,
  moreLabel,
  lessLabel = 'Show less',
}: ShowMoreToggleProps) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={expanded}
      className="mt-3 flex w-full items-center justify-center gap-1 rounded-md border-t border-gray-200/70 pt-3 text-xs font-semibold text-blue-600 transition-colors hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 dark:border-gray-800 dark:text-blue-400 dark:hover:text-blue-300"
    >
      <span>{expanded ? lessLabel : moreLabel}</span>
      <ChevronDownIcon
        aria-hidden
        className={`h-3.5 w-3.5 transition-transform ${
          expanded ? 'rotate-180' : ''
        }`}
      />
    </button>
  );
};

export type { ShowMoreToggleProps };
export default ShowMoreToggle;
